<template>
    <!-- <b-modal ref="mdlRsaSchedaAnamnesiaStoriaClinicaEditComponent" size="lg" title="Scheda Anamnesi/Storia Clinica" @hidden="onCloseModal" @ok="onSalvaAnamnesiStoriaClinica" centered no-close-on-backdrop no-close-on-esc hide-header-close> -->
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <!-- <b-card class="sa-card sa-card-border" header="Valutazione" header-tag="header" footer-tag="footer" title=""> -->
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Storia Clinica</label>
                    <span v-if="isReadOnly">{{ jsonDataAnamnesiaStoriaClinica.storiaClinica }}</span>
                    <b-form-textarea v-else v-model="jsonDataAnamnesiaStoriaClinica.storiaClinica" max-rows="20" rows="10" :readonly="isReadOnly"></b-form-textarea>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Anamnesi</label>
                    <span v-if="isReadOnly">{{ jsonDataAnamnesiaStoriaClinica.anamnesia }}</span>
                    <b-form-textarea v-else v-model="jsonDataAnamnesiaStoriaClinica.anamnesia" max-rows="20" rows="10" :readonly="isReadOnly"></b-form-textarea>
                </b-col>
            </b-row>
            <!-- </b-card> -->
        </b-col>
    </b-row>
    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlRsaSchedaAnamnesiaStoriaClinicaEditComponent.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaAnamnesiStoriaClinica()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlRsaSchedaAnamnesiaStoriaClinicaEditComponent.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
        jsonDataAnamnesiaStoriaClinica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    storiaClinica: "",
                    anamnesia: "",
                };
            },
        },
    },

    mounted() {
        let me = this;
        if (me.idRisorsa !== null) {
            me.visualizzaAnamnesiaStoriaClinica();
        }
    },
    watch: {
        jsonDataAnamnesiaStoriaClinica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResource: "/rsaanamnesistoriaclinica",
            pathResourceCheck: "/rsaanamnesistoriaclinica/check",
        };
    },
    methods: {
        visualizzaAnamnesiaStoriaClinica() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            /* me.jsonDataAnamnesiaStoriaClinica = response.data.data; */
            Object.keys(response.data.data).forEach((key) => {
                me.jsonDataAnamnesiaStoriaClinica[key] = response.data.data[key];
            });
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onSalvaAnamnesiStoriaClinica() {
            let me = this;
            if (!me.jsonDataAnamnesiaStoriaClinica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataAnamnesiaStoriaClinica, me.saveAnamnesiaStoriaClinicaSuccessResponse, me.saveAnamnesiaStoriaClinicaErrorResponse);
        },
        saveAnamnesiaStoriaClinicaSuccessResponse() {
            let me = this;
            me.$emit("afterSaveSuccess");
            me.$refs.mdlRsaSchedaAnamnesiaStoriaClinicaEditComponent.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveAnamnesiaStoriaClinicaErrorResponse(response) {
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                this.$bvToast.toast("Errore nel salvataggio" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        /* onCloseModal() {
            let me = this;
            me.jsonDataAnamnesiaStoriaClinica = {};
            me.$emit("onClose");
        }, */

        /* nuovoAnamnesiaStoriaClinica() {
            let me = this;
            me.isReadOnly = false;
            me.jsonDataAnamnesiaStoriaClinica = {
                id: null,
                idAccettazione: me.idAccettazione,
                storiaClinica: null,
                anamnesia: null,
            };
        }, */
    },
};
</script>
